import { Text } from '@rbilabs/universal-components';

export const Price = Text.withConfig({
  variant: 'copyOne',
  fontWeight: 'bold',
  paddingLeft: '$2',
});
